<div class="modal-container">
  <div class="modal-header">
    <div class="header-content">
      <mat-icon class="header-icon">settings</mat-icon>
      <div class="header-text">
        <h2>API Configuration</h2>
        <span class="user-name">{{ data.userName }}</span>
      </div>
    </div>
    <button mat-icon-button class="close-btn" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p class="description">Enable or disable API features for this user</p>
    <form [formGroup]="apiConfigForm" (ngSubmit)="onSubmit()">
      <div class="config-options">
        <div
          class="config-item"
          *ngFor="let option of configOptions"
          [class.enabled]="apiConfigForm.get(option.key)?.value"
        >
          <div class="config-info">
            <mat-icon class="config-icon">{{ option.icon }}</mat-icon>
            <div class="config-text">
              <span class="config-label">{{ option.label }}</span>
              <span class="config-desc">{{ option.description }}</span>
            </div>
          </div>
          <mat-slide-toggle
            [formControlName]="option.key"
            color="primary"
          ></mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <app-common-button
      text="Cancel"
      variant="secondary"
      (onClick)="onCancel()"
      [disabled]="isLoading"
      [type]="'button'"
    ></app-common-button>
    <app-common-button
      text="Save Changes"
      variant="primary"
      (onClick)="onSubmit()"
      [disabled]="isLoading"
      [type]="'submit'"
    ></app-common-button>
  </mat-dialog-actions>
</div>
